import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { lumi } from '@/lib/lumi';
import { ensureProfile, type ProfileKind } from '@/lib/profileStore';
import Navbar from '@/components/Navbar';

export default function CompletarCadastro() {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [kind, setKind] = useState<ProfileKind>('trabalhador');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  if (!isAuthenticated || !user) return <Navigate to="/cadastro" replace />;
  const complete = async () => {
    if (busy) return;
    setBusy(true); setError('');
    try {
      await ensureProfile(lumi.entities.user_profiles, user, kind);
      navigate('/perfil', {replace: true});
    } catch (e) { setError(e instanceof Error ? e.message : 'Não foi possível concluir. Tente novamente.'); }
    finally { setBusy(false); }
  };
  return <div className="min-h-screen bg-[#1a1a1a] text-white"><Navbar />
    <main className="max-w-lg mx-auto px-4 py-12">
      <h1 className="text-2xl font-bold mb-3">Complete seu cadastro</h1>
      <p className="text-gray-300 mb-6">Sua conta já existe. Escolha como deseja participar do BBQ Jobs.</p>
      <label htmlFor="profile-kind">Tipo de perfil</label>
      <select id="profile-kind" value={kind} disabled={busy} onChange={e => setKind(e.target.value as ProfileKind)} className="block w-full bg-[#333] p-3 rounded-xl my-3">
        <option value="trabalhador">Trabalhador</option><option value="restaurante">Estabelecimento</option>
      </select>
      {error && <p role="alert" className="text-red-300 my-3">{error}</p>}
      <button disabled={busy} onClick={complete} className="bg-[#E53935] p-3 rounded-xl disabled:opacity-50">{busy ? 'Salvando...' : 'Concluir cadastro'}</button>
    </main>
  </div>;
}
